export default {
  "<router-link>": {
    "title": "Props",
    "url": "#router-link-props",
    "sub": {
      "to": "#to",
      "replace": "#replace",
      "append": "#append",
      "tag": "#tag",
      "active-class": "#active-class",
      "exact": "#exact",
      "event": "#event",
      "exact-active-class": "#exact-active-class",
      "aria-current-value": "#aria-current-value"
    }
  },
  "<router-view>": {
    "title": "Props",
    "url": "#router-view-props",
    "sub": {
      "name": "#name"
    }
  },
  "构建选项": {
    "title": "Options",
    "url": "#router-构建选项",
    "sub": {
      "routes": "#routes",
      "mode": "#mode",
      "base": "#base",
      "linkActiveClass": "#linkactiveclass",
      "linkExactActiveClass": "#linkexactactiveclass",
      "scrollBehavior": "#scrollbehavior",
      "parseQuery / stringifyQuery": "#parsequery-stringifyquery",
      "fallback": "#fallback"
    }
  },
  "实例属性": {
    "title": "Instance",
    "url": "#router-实例属性",
    "sub": {
      "router.app": "#router-app",
      "router.mode": "#router-mode",
      "router.currentRoute": "#router-currentroute"
    }
  },
  "实例方法": {
    "title": "Instance",
    "url": "#router-实例方法",
    "sub": {
      "router.beforeEach": "#router-beforeeach",
      "router.beforeResolve": "#router-beforeresolve",
      "router.afterEach": "#router-aftereach",
      "router.push": "#router-push",
      "router.replace": "#router-replace",
      "router.go": "#router-go",
      "router.back": "#router-back",
      "router.forward": "#router-forward",
      "router.getMatchedComponents": "#router-getmatchedcomponents",
      "router.resolve": "#router-resolve",
      "router.addRoutes": "#router-addroutes",
      "router.onReady": "#router-onready",
      "router.onError": "#router-onerror"
    }
  },
  "属性": {
    "title": "路由对象",
    "url": "#路由对象",
    "sub": {
      "$route.path": "#路由对象",
      "$route.params": "#路由对象",
      "$route.query": "#路由对象",
      "$route.hash": "#路由对象",
      "$route.fullPath": "#路由对象",
      "$route.matched": "#路由对象",
      "$route.name": "#路由对象",
      "$route.redirectedFrom": "#路由对象"
    }
  },
  "组件内守卫" : {
    "title": "",
    "url": "guide/advanced/navigation-guards.html#组件内的守卫",
    "sub": {
      "beforeRouteEnter": "guide/advanced/navigation-guards.html#组件内的守卫",
      "beforeRouteUpdate": "guide/advanced/navigation-guards.html#组件内的守卫@2.2",
      "beforeRouteLeave": "guide/advanced/navigation-guards.html#组件内的守卫"
    }
  }
}
